import { environment } from '@enviroment/environment';

export function regionWord(text: string | null | undefined): string {
  if (!text) return '';

  if (environment.region !== 'ES') {
    return text;
  }

  return text
    // =========================
    // COLONIA -> PROVINCIA
    // =========================
    .replace(/\bCOLONIAS\b/g, 'PROVINCIAS')
    .replace(/\bCOLONIA\b/g, 'PROVINCIA')
    .replace(/\bColonias\b/g, 'Provincias')
    .replace(/\bColonia\b/g, 'Provincia')
    .replace(/\bcolonias\b/g, 'provincias')
    .replace(/\bcolonia\b/g, 'provincia')

    // =========================
    // SUCURSAL -> CONSULTORIO
    // =========================
    .replace(/\bSUCURSALES\b/g, 'CONSULTORIOS')
    .replace(/\bSUCURSAL\b/g, 'CONSULTORIO')
    .replace(/\bSucursales\b/g, 'Consultorios')
    .replace(/\bSucursal\b/g, 'Consultorio')
    .replace(/\bsucursales\b/g, 'consultorios')
    .replace(/\bsucursal\b/g, 'consultorio');
}
